module.exports = __webpack_public_path__ + "static/media/suit.0baf4a89.png";